import { useEffect, useState, type RefObject } from 'react';

// O TEMA QUE ESTÁ NA PÁGINA (a classe `cds--white`/`cds--g100` no <html>), e não a preferência
// guardada: é ele que o carbon.scss pinta, e é ele que um gráfico do Carbon tem de seguir para não
// sair escuro numa página clara. Troca junto com a classe.

const agora = (): 'white' | 'g100' => (
  typeof document !== 'undefined' && document.documentElement.classList.contains('cds--g100') ? 'g100' : 'white'
);

export const useTemaDaPagina = () => {
  const [tema, setTema] = useState(agora);
  useEffect(() => {
    const observador = new MutationObserver(() => setTema(agora()));
    observador.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    setTema(agora());
    return () => observador.disconnect();
  }, []);
  return tema;
};

// O TEMA DO LUGAR: o da zona em volta do elemento (um `<Theme>` do Carbon põe a classe do tema no
// bloco dele), e o da página quando não há zona. É o que o gráfico precisa numa zona escura por
// desenho, como a Nyta na landing, que é `g100` dentro de uma página clara.
const TEMAS = ['white', 'g10', 'g90', 'g100'] as const;
type TemaDoCarbon = (typeof TEMAS)[number];

const doLugar = (el: HTMLElement | null): TemaDoCarbon => {
  const zona = el?.closest(TEMAS.map((t) => `.cds--${t}`).join(', '));
  return TEMAS.find((t) => zona?.classList.contains(`cds--${t}`)) ?? agora();
};

export const useTemaDoLugar = (alvo: RefObject<HTMLElement | null>) => {
  const daPagina = useTemaDaPagina();
  const [tema, setTema] = useState<TemaDoCarbon>(daPagina);
  useEffect(() => { setTema(doLugar(alvo.current)); }, [alvo, daPagina]);
  return tema;
};
